import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import app from './reducers';
import { historyMiddleware } from './Middlewares/History.middleware';
import MiniCartAddedItems from './Components/MiniCartAddedItems';
import ModalContainer from './Containers/Modal.container';
import SaveCartPopUpContainer from './Containers/SaveCartPopUp.container';
import ClearAllCartPopUpContainer from './Containers/ClearAllCartPopUp.container';
import OrderConfirmationGAContainer from './Containers/OrderConfirmationGA.container'
import QuickSearchContainer from './Containers/QuickSearch.container';
import NavigationContainer from './Containers/Navigation.container';
import FacetedSearchContainer from './Containers/FacetedSearch.container';
import FactedSeachClearButtonContainer from './Containers/FactedSeachClearButton.container';
import FacetedSearchCompactContainer from './Containers/FacetedSearchCompact.container';
import NotificationContainer from './Containers/Notification.container';
import DynamicComponent from './Components/DynamicComponent';
import BackToTopButton from './Components/BackToTopButton';
import ResellerMapContainer from './Containers/ResellerMap.container';
import ERPDatePicker from './Containers/ERPDatePicker.container'
import ResetPasswordContainer from './Components/ResetPassword'
import ReadMore from './Containers/ReadMore.container'
import { get } from '../Scripts/Services/http';
import LiveEditing from './Components/LiveEditing';

window.__litium = window.__litium || {};
const preloadState = window.__litium.preloadState || {};
export const store = createStore(
    app,
    preloadState,
    composeWithDevTools(applyMiddleware(thunk, historyMiddleware))
);

// Add a dictionary to keep track of the registered async reducers
store.asyncReducers = {};

// Create an inject reducer function
// This function adds the async reducer, and creates a new combined reducer
store.injectReducer = (key, asyncReducer) => {
    if (!store.asyncReducers[key]) {
        store.asyncReducers[key] = asyncReducer;
        store.replaceReducer(createReducer(store.asyncReducers));
    }
};

window.__litium = {
    ...window.__litium,
    bootstrapComponents: () => {
        // bootstrap React components, in case the HTML response we receive from the server
        // has React components. ReactDOM.render performs only an update on previous rendered
        // components and only mutate the DOM as necessary to reflect latest React element.
        bootstrapComponents();
    },
    cache: {}, // for storing cache data for current request
};

const registeredContainers = [];
export const renderReact = (element, container, callback) => {
    registeredContainers.push(container);
    ReactDOM.render(element, container, callback);
};

window.onunload = () => {
    // make sure components are unmounted, redux's listener are unsubscribed
    // to fix issue with iframe navigation in IE
    registeredContainers.forEach((container) => {
        ReactDOM.unmountComponentAtNode(container);
    });
};

const bootstrapComponents = () => {
  if (document.getElementById('minicart-items')) {
    renderReact(
      <Provider store={store}>
        <MiniCartAddedItems />
      </Provider>,
      document.getElementById('minicart-items')
    );
  }
  if (document.getElementById('liveEditing')) {
        renderReact(
            <Provider store={store}>
                <LiveEditing />
            </Provider>,
            document.getElementById('liveEditing')
        );
    }
  if (document.getElementById('quickSearch')) {
    renderReact(
      <Provider store={store}>
        <QuickSearchContainer />
      </Provider>,
      document.getElementById('quickSearch')
    );
  }
  if (document.getElementById('navbar')) {
    renderReact(
      <Provider store={store}>
        <NavigationContainer />
      </Provider>,
      document.getElementById('navbar')
    );
  }
  if (document.getElementById('clearFilterButton')) {
    renderReact(
      <Provider store={store}>
        <FactedSeachClearButtonContainer />
      </Provider>,
      document.getElementById('clearFilterButton')
    );
  }
  if (document.getElementById('facetedSearch')) {
    renderReact(
      <Provider store={store}>
        <FacetedSearchContainer />
      </Provider>,
      document.getElementById('facetedSearch')
    );
  }
  if (document.getElementById('facetedSearchCompact')) {
    renderReact(
      <Provider store={store}>
        <FacetedSearchCompactContainer />
      </Provider>,
      document.getElementById('facetedSearchCompact')
    );
  }
  if (document.getElementById('orderconfirmation_ga')) {
    let order = document.getElementById('orderconfirmation_ga');
    renderReact(
      <Provider store={store}>
        <OrderConfirmationGAContainer axNumber={order.dataset.axnumber} />
      </Provider>,
      document.getElementById('orderconfirmation_ga')
    );
  }

  if (document.getElementById('read-more')) {
    let data = document.getElementById('read-more');
    renderReact(
      <Provider store={store}>
        <ReadMore data={data.dataset} />
      </Provider>,
      document.getElementById('read-more')
    );
  }

  if (document.querySelectorAll('.singleDatePicker').length > 0) {
    Array.from(document.querySelectorAll('.singleDatePicker')).forEach((items, index) => {
      renderReact(<ERPDatePicker id={items.dataset.id} selecteddate={items.dataset.selectedate} placeholder={items.dataset.placeholder} />, items);
    });
  }

  if (document.getElementById('globalNotification')) {
    renderReact(
      <Provider store={store}>
        <NotificationContainer />
      </Provider>,
      document.getElementById('globalNotification')
    );
  }

  if (document.getElementById('modal-container')) {
    renderReact(
      <Provider store={store}>
        <ModalContainer />
      </Provider>,
      document.getElementById('modal-container')
    );
  }
  if (document.getElementById('savecartmodal-container')) {
    renderReact(
      <Provider store={store}>
        <SaveCartPopUpContainer />
      </Provider>,
      document.getElementById('savecartmodal-container')
    );
  }

  if (document.getElementById('clearallcartmodal-container')) {
    renderReact(
      <Provider store={store}>
        <ClearAllCartPopUpContainer />
      </Provider>,
      document.getElementById('clearallcartmodal-container')
    );
  }

  if (document.getElementById('myPagePersons')) {
    const PersonList = DynamicComponent({
      loader: () => import('./Containers/PersonList.container'),
    });
    renderReact(
      <Provider store={store}>
        <PersonList />
      </Provider>,
      document.getElementById('myPagePersons')
    );
  }
  if (document.getElementById('myPageAddresses')) {
    const AddressList = DynamicComponent({
      loader: () => import('./Containers/AddressList.container'),
    });
    renderReact(
      <Provider store={store}>
        <AddressList />
      </Provider>,
      document.getElementById('myPageAddresses')
    );
  }
  if (document.getElementById('checkout')) {
    const Checkout = DynamicComponent({
      loader: () => import('./Containers/Checkout.container'),
    });
    renderReact(
      <Provider store={store}>
        <Checkout />
      </Provider>,
      document.getElementById('checkout')
    );
  }
  if (document.getElementById('productConfigurator')) {
    const ProductConfigurator = DynamicComponent({
      loader: () => import('./Containers/ProductConfigurator.container'),
    });
    const configurator = document.getElementById('productConfigurator');
    renderReact(
      <Provider store={store}>
        <ProductConfigurator modal={false} articleNumber={configurator.dataset.articlenumber} alloySurcharge={configurator.dataset.alloySurcharge} defaultPurchaseUnit={configurator.dataset.defaultPurchaseUnit} />
      </Provider>,
      configurator
    );
  }

  if (document.querySelectorAll('.slider').length > 0) {
    const Slider = DynamicComponent({
      loader: () => import('./Components/Slider'),
    });
    Array.from(document.querySelectorAll('.slider')).forEach((slider, index) => {
      const sliderSettings = {
          autoPlay: (slider.dataset.autoplay == 'True' ? true : false),
          interval: (slider.dataset.numberofseconds != 0 ? slider.dataset.numberofseconds * 1000 : 3000),
      }
      const values = [...slider.querySelectorAll('.slider__block')].map((block) => {
        return {
          image: block.dataset.image,
          url: block.dataset.url,
          text: block.dataset.text,
        };
      });

      if (values.length > 0) {
        renderReact(<Slider values={values} sliderSettings={sliderSettings}/>, slider);
      }
    });
  }

  if (document.querySelectorAll('.newsslider').length > 0) {
    const Slider = DynamicComponent({
      loader: () => import('./Components/NewsBlockSlider'),
    });
    Array.from(document.querySelectorAll('.newsslider')).forEach((slider, index) => {
      const { itemstodisplay, urlredirect } = slider.dataset;
      const values = [...slider.querySelectorAll('.newsslider__block')].map((block) => {
        return {
          image: block.dataset.image,
          url: block.dataset.url,
          text: block.dataset.text,
          desc: block.dataset.desc,
          exteranalurl: block.dataset.externalurl,
          textcolor: block.dataset.textcolor
        };
      });
      if (values.length > 0) {
        renderReact(<Slider values={values} itemstodisplay={itemstodisplay} urlredirect={urlredirect} />, slider);
      }
    });
  }

  if (document.querySelectorAll('config-button').length > 0) {
    const ConfigButton = DynamicComponent({
      loader: () => import('./Containers/ConfigButton.container'),
    });

    Array.from(document.querySelectorAll('config-button')).forEach((button) => {
      const { articlenumber, cssclass, orderrow } = button.dataset;
      const label = button.innerHTML,
        presets = JSON.parse(button.dataset.presets);
      renderReact(
        <Provider store={store}>
          <ConfigButton {...{ articleNumber:articlenumber, orderRow:orderrow, presets, cssClass:cssclass, label }} />
        </Provider>,
        button
      );
    });
  }


  if (document.querySelectorAll('organization-list').length > 0) {
    const OrganizationList = DynamicComponent({
      loader: () => import('./Containers/OrganizationList.container'),
    });
    Array.from(document.querySelectorAll('organization-list')).forEach((item) => {
      const { selectedorganizationname, redirecturl, selectedorganizationnumber } = item.dataset;

      renderReact(
        <Provider store={store}>
          <OrganizationList {...{ 
            selectedOrganizationName: selectedorganizationname, 
            selectedOrganizationNumber: selectedorganizationnumber, 
            redirectUrl: redirecturl 
            }} />
        </Provider>,
        item
      );
    });
  }

  if (document.querySelector('#test-component')) {
    const TestComponent = DynamicComponent({
      loader: () => import('./Containers/Test.Container'),
    });

    renderReact(
      <Provider store={store}>
        <TestComponent />
      </Provider>,
      document.querySelector('#test-component')
    );
  }

  if (document.querySelectorAll('buy-button').length > 0) {
    const BuyButton = DynamicComponent({
      loader: () => import('./Containers/BuyButton.Container'),
    });
    Array.from(document.querySelectorAll('buy-button')).forEach((button) => {
      const { articleNumber, quantityFieldId, href, cssClass, label } = button.dataset;
      renderReact(
        <Provider store={store}>
          <BuyButton {...{ label, articleNumber, quantityFieldId, href, cssClass }} />
        </Provider>,
        button
      );
    });
  }

  if (document.querySelectorAll('reorder-button').length > 0) {
    const ReorderButton = DynamicComponent({
      loader: () => import('./Containers/ReorderButton.Container'),
    });
    Array.from(document.querySelectorAll('reorder-button')).forEach((button) => {
      const { cssClass, orderId, title } = button.dataset;
      const label = button.innerText;
      renderReact(
        <Provider store={store}>
          <ReorderButton {...{ label, title, cssClass, orderId }} />
        </Provider>,
        button
      );
    });
  }
  if (document.querySelectorAll('.favouritesdata').length > 0) {
    const FavouritesContainer = DynamicComponent({
      loader: () => import('./Containers/Favourites.Container'),
    });
    Array.from(document.querySelectorAll('.favouritesdata')).forEach((Favourites) => {
      var data = Favourites.dataset;
      renderReact(
        <Provider store={store}>
          <FavouritesContainer {...data} />
        </Provider>,
        Favourites
      );
    });
  }

  if (document.querySelectorAll('.saved-cart-list').length > 0) {
    const SavedCartContainer = DynamicComponent({
      loader: () => import('./Containers/SavedCart.container'),
    });

    Array.from(document.querySelectorAll('.saved-cart-list')).forEach((savedCart) => {
      const hideProductPurchaseOrg = savedCart.dataset.hideproductpurchaseorg === 'True';
      renderReact(
        <Provider store={store}>
          <SavedCartContainer hideProductPurchaseOrg = {hideProductPurchaseOrg} />
        </Provider>,
        savedCart
      );
    });
  }


  if (document.querySelectorAll('deliverydetailsiframe').length > 0) {
    const DeliveryDetailIframe = DynamicComponent({
      loader: () => import('./Containers/DeliveryDetailFrame.container'),
    });
    Array.from(document.querySelectorAll('deliverydetailsiframe')).forEach((item) => {
      const { id, datevalue, url } = item.dataset;
      renderReact(
        <Provider store={store}>
          <DeliveryDetailIframe id={id} datevalue={datevalue} url={url}></DeliveryDetailIframe>
        </Provider>,
        item
      );
    });
  }

  if (document.querySelectorAll('config-stock').length > 0) {
    const ConfigStock = DynamicComponent({
      loader: () => import('./Containers/ConfigStock.container'),
    });
    let arrayarticleList = [];
    Array.from(document.querySelectorAll('config-stock')).forEach((stock) => {
      const { articlenumber } = stock.dataset;
      arrayarticleList.push(articlenumber);
    });
    Array.from(document.querySelectorAll('config-stock')).forEach((stock) => {
      const { id, showitem, isauthendicated,loginurl,becomecustomer } = stock.dataset;
      let isauthorized = isauthendicated == 'true' ? true : false;
      renderReact(
        <Provider store={store}>
          <ConfigStock {...{ arrayarticleList, id, showItem:showitem, isauthorized,loginUrl:loginurl,becomeCustomer:becomecustomer }} />
        </Provider>,
        stock
      );
      arrayarticleList = [];
    });
  }
  if (document.querySelectorAll('reseller-map').length > 0) {
    Array.from(document.querySelectorAll('reseller-map')).forEach((reseller) => {
      var items = JSON.parse(reseller.dataset.resellers);
      const { lat, longt } = reseller.dataset;
      renderReact(
        <Provider store={store}>
          <ResellerMapContainer {...{ items, lat, longt }} />
        </Provider>,
        reseller
      );
    });
  }
  if (document.querySelectorAll('#keepalive').length > 0) {
    const rootRoute = '/api/utility/KeepSessionAlive?time=' + Date();
    setInterval(() => get(rootRoute), 250000);
  }
  if (document.querySelectorAll('resetpassword').length > 0) {
    Array.from(document.querySelectorAll('resetpassword')).forEach((resetpassword) => {
      renderReact(
        <Provider store={store}>
          <ResetPasswordContainer />
        </Provider>,
        resetpassword
      );
    });
  }

  if (document.getElementById('backtotop')) {
    renderReact(
      <Provider store={store}>
        <BackToTopButton />
      </Provider>,
      document.getElementById('backtotop')
    );
  }

  if (document.querySelectorAll('order-to-cart').length > 0) {
    const OrderToCart = DynamicComponent({
      loader: () => import('./Components/OrderToCart'),
    });

    Array.from(document.querySelectorAll('order-to-cart')).forEach((button) => {
      const { orderid } = button.dataset;
      renderReact(
        <Provider store={store}>
          <OrderToCart orderId={orderid}  />
        </Provider>,
        button
      );
    });
  }

  if (document.getElementById('translate-to-english-checkbox')) {
    const TranslateToEnglishCheckBox = DynamicComponent({
      loader: () => import('./Components/TranslateToEnglishCheckBox'),
    });
    const translateToEnglishCheckBox = document.getElementById('translate-to-english-checkbox');
    const { selected } = translateToEnglishCheckBox.dataset;
    renderReact(
      <Provider store={store}>
        <TranslateToEnglishCheckBox selected={selected.toLowerCase() == 'true' ? true : false} />
      </Provider>,
      translateToEnglishCheckBox
    );
  }

  if (document.getElementById('quickAddToCart')) {
    const HeaderAddToCart = DynamicComponent({
      loader: () =>
        import('./Components/QuickAddToCart'),
    });
    const quickAddToCart = document.getElementById(
      'quickAddToCart'
    );
    
    renderReact(
      <Provider store={store}>
        <HeaderAddToCart />
      </Provider>,
      quickAddToCart
    );
  }

  if (document.querySelectorAll('walkthrough-trigger').length > 0) {    
    const Walkthrough = DynamicComponent({
      loader: () => import('./Components/Walkthrough/Walkthrough')
    });

    Array.from(document.querySelectorAll('walkthrough-trigger')).forEach((item) => {
      renderReact(<Walkthrough {...item.dataset} />, item);
    });
  }

};
bootstrapComponents();
